<script setup lang="ts">
  import { useTemplateStore } from '@/store/template.store'
  import TopBar from '@/components/TopBar.vue'
  import { Table, UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { isAxiosError } from 'axios'
  import { onMounted, ref } from 'vue'
  import { useRouter } from 'vue-router'

  const templateStore = useTemplateStore()
  const router = useRouter()

  const errorMessage = ref<string | null>()

  onMounted(async () => {
    await fetchTemplates()
  })

  async function fetchTemplates() {
    try {
      await templateStore.fetchAll()
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 403) {
        errorMessage.value = error.response.data.message
      } else {
        throw error
      }
    }
  }
</script>

<template>
  <TopBar />
  <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
  <div class="layout" v-else>
    <Table
      :rows="templateStore.templates"
      :columns="[
        { key: 'id', label: 'ID' },
        {
          key: 'name',
          label: 'Naam',
          searchable: true,
        },
        {
          key: 'number',
          label: 'Template Nummer',
          searchable: true,
        },
        { key: 'fromAddress', label: 'Herkomst', searchable: true },
        { key: 'toAddress', label: 'Bestemming', searchable: true },
        { key: 'action', label: 'Acties', sticky: 'right' },
      ]"
      :searchable="true"
      :configurable="true"
    >
      <template #table-top-actions>
        <UiButton
          class="create-button"
          label="Nieuw Template"
          variant="prominent"
          icon="plus"
          @click="router.push({ name: 'template-new' })"
        />
      </template>
      <template #cell-action="{ row }">
        <UiButton
          size="small"
          label="Aanpassen"
          variant="prominent"
          @click="router.push({ name: 'template-edit', params: { templateId: row.id } })"
        />
      </template>
      <template #cell-fromAddress="{ row }">{{ row.fromAddress.street2 }}</template>
      <template #cell-toAddress="{ row }">{{ row.toAddress.street2 }}</template>
      <template #cell-number="{ row }">{{
        row.bgb?.groupId ?? row.ecmr?.domainIdentifier ?? 'N/A'
      }}</template>
    </Table>
  </div>
</template>

<style lang="css" scoped>
  .error-message {
    color: var(--colours-support-negative);
  }

  .create-button {
    align-self: end;
  }

  .button-group {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-xs);
  }

  .layout {
    display: flex;
    padding: var(--spacing-m);
    flex-direction: column;
    gap: var(--spacing-s);
    height: 100vh;
  }
</style>
